import { Component, Input } from '@angular/core';

import { User } from '../../../models/Core/User';
import { Idea } from '../../../models/Sessions/Idea/Idea';

@Component({
  selector: 'app-filtered-results-toggle',
  templateUrl: './filtered-results-toggle.component.html',
  styleUrls: ['./filtered-results-toggle.component.scss'],
})
export class FilteredResultsToggleComponent {
  @Input() ideas: Idea[];
  @Input() users: User[];
  @Input() ideaIdToSession: object;
  showUser = false;

  showUsers() {
    this.showUser = true;
  }

  showIdeas() {
    this.showUser = false;
  }
}
